module.exports = __webpack_public_path__ + "static/assets/ec0a5e21bede29ad9138f58c9b044ed6.svg";